import React, { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react"; 
import axios from "axios";

// Assets
import BackgroundImage from "../../../src/assets/images/6c5785f17de49e844cdd5363b9709c29ab5fa751.png";
import ChangeBackground from "../../../src/assets/images/IMG_8878.JPG";

// Components
import PopularCourses from "./popularcourses"
import HomeSucess from "./homesucess";
import Work from "./works";
//import Service from "./HomeOurservice";
import HomePeermate from "./HomePeermate";
import Categories from "./Categories";
import TutorCards from "../../components/TutorCards";
import Hubs from "./hubs";
import HomeTestimony from "./HomeTestimony";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const OutsourcingSection = () => {
  const navigate = useNavigate();
  const [bgIndex, setBgIndex] = useState(0);
  const [textIndex, setTextIndex] = useState(0);
  const [bubbles, setBubbles] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [approvedCourses, setApprovedCourses] = useState([]);

  const images = [BackgroundImage, ChangeBackground];
  const labels = ["Online Classes", "Onsite Classes", "AI-Powered Learning"];
  
  // Tag names with their corresponding routes
  const popularTags = [
    { name: "Peermate Ai", path: "/peerchat" },
    { name: "Join Virtual Class", path: "/Howitworks" },
    { name: "Marketplace", path: "/Howitworks" }
  ];

  useEffect(() => {
    const fetchApprovedCourses = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/students/approved-courses`);
        setApprovedCourses(res.data.data || []);
      } catch (err) {
        console.error("❌ Failed to fetch approved courses:", err);
      }
    };

    fetchApprovedCourses();
  }, []);

  const handleSearch = () => {
    const query = searchQuery.trim();
    if (!query) {
      navigate("/tutors");
      return;
    }

    navigate(`/tutors?course=${encodeURIComponent(query)}`);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const matchedCourses = approvedCourses
    .filter((item) =>
      String(item.course_name || "")
        .toLowerCase()
        .includes(searchQuery.trim().toLowerCase())
    )
    .slice(0, 6);

  useEffect(() => {
    const bgInterval = setInterval(() => setBgIndex((prev) => (prev + 1) % images.length), 5000);
    const textInterval = setInterval(() => setTextIndex((prev) => (prev + 1) % labels.length), 3000);
    return () => { 
      clearInterval(bgInterval); 
      clearInterval(textInterval); 
    };
  }, []);

  const createFoamBurst = useCallback((e) => {
    const newBubbles = Array.from({ length: 12 }).map((_, i) => ({
      id: Date.now() + i,
      x: e.clientX,
      y: e.clientY,
      size: Math.random() * 30 + 10,
      drift: (Math.random() - 0.5) * 150,
    }));

    setBubbles((prev) => [...prev, ...newBubbles]);
    setTimeout(() => {
      setBubbles((prev) => prev.filter((b) => !newBubbles.includes(b)));
    }, 1000);
  }, []);

  const buttonVariants = {
    hover: { scale: 1.03, boxShadow: "0px 15px 40px rgba(25, 118, 210, 0.5)" },
    tap: { scale: 0.94 },
  };

  return (
    <>
      {/* MAGIC FOAM LAYER */}
      <div className="fixed inset-0 pointer-events-none z-[100] overflow-hidden">
        <AnimatePresence>
          {bubbles.map((bubble) => (
            <motion.div
              key={bubble.id}
              initial={{ opacity: 0.8, scale: 0, x: bubble.x, y: bubble.y }}
              animate={{ 
                opacity: 0, 
                scale: 1.5, 
                x: bubble.x + bubble.drift, 
                y: bubble.y - 150 
              }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="absolute bg-white/40 backdrop-blur-sm border border-white/60 rounded-full"
              style={{ width: bubble.size, height: bubble.size }}
            />
          ))}
        </AnimatePresence>
      </div>


      <section className="w-full min-h-[42rem] md:min-h-[48rem] relative flex flex-col items-center justify-center px-6 overflow-hidden bg-slate-900 py-20">
        {/* Background Images Layer */}
        <AnimatePresence mode="wait">
          <motion.div
            key={bgIndex}
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
            style={{ backgroundImage: `url(${images[bgIndex]})` }}
            className="absolute inset-0 bg-cover bg-center"
          />
        </AnimatePresence>

        {/* Overlay Darkener */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/70"></div>

        {/* Heading */}
        <motion.h1
          className="text-white text-4xl md:text-6xl font-black text-center z-20 max-w-5xl tracking-tight leading-[1.1]"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Peer With a Tutor, <br /> Progress with <br></br>
          Purpose.      </motion.h1>

        {/* SEARCH BAR (Fiverr Style) */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="z-20 w-full max-w-3xl mt-10"
        >
          <div className="relative group flex items-center shadow-2xl">
            <input
              type="text"
              placeholder="Search for any Course..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={handleSearchKeyDown}
              className="w-full h-[56px] md:h-[68px] pl-6 pr-16 rounded-xl bg-white text-slate-900 text-lg font-medium focus:outline-none transition-all border-2 border-transparent focus:border-[#1976D2]/50"
            />
            <button
              type="button"
              onClick={handleSearch}
              className="absolute right-2 w-[44px] md:w-[54px] h-[44px] md:h-[54px] bg-slate-900 hover:bg-black text-white rounded-lg flex items-center justify-center transition-all active:scale-90"
            >
              <Search size={24} />
            </button>
          </div>

          {searchQuery.trim() && matchedCourses.length > 0 && (
            <div className="mt-3 rounded-xl bg-white/95 backdrop-blur-sm border border-white/60 overflow-hidden">
              {matchedCourses.map((item, idx) => (
                <button
                  key={`${item.id}-${idx}`}
                  type="button"
                  onClick={() => navigate(`/tutors?course=${encodeURIComponent(item.course_name || "")}`)}
                  className="w-full text-left px-4 py-3 text-sm text-slate-700 hover:bg-slate-100 transition-colors"
                >
                  {item.course_name}
                </button>
              ))}
            </div>
          )}

          {/* POPULAR TAGS WITH LINKS */}
          <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
            <span className="text-white/80 font-bold text-sm mr-2">Popular:</span>
            {popularTags.map((tag, idx) => (
              <Link key={idx} to={tag.path}>
                <motion.button
                  whileHover={{ scale: 1.05, backgroundColor: "rgba(255, 255, 255, 0.25)" }}
                  className="px-4 py-1.5 border border-white/50 rounded-full text-white text-[12px] md:text-[13px] font-bold flex items-center gap-2 backdrop-blur-md transition-all whitespace-nowrap"
                >
                  {tag.name} <ArrowRight size={14} className="opacity-70" />
                </motion.button>
              </Link>
            ))}
          </div>
        </motion.div>

        {/* ORIGINAL ACTION BUTTONS */}
        <div className="flex flex-col sm:flex-row items-center gap-5 mt-14 z-20 w-full sm:w-auto">
          <motion.button
            onClick={createFoamBurst}
            variants={buttonVariants}
            whileHover="hover"
            whileTap="tap"
            className="relative w-full sm:w-auto min-w-[240px] bg-[#1976D2] text-white h-[60px] rounded-2xl overflow-hidden shadow-2xl transition-colors duration-300"
          >
            <AnimatePresence mode="wait">
              <motion.span
                key={textIndex}
                initial={{ rotateX: -90, opacity: 0, y: 20 }}
                animate={{ rotateX: 0, opacity: 1, y: 0 }}
                exit={{ rotateX: 90, opacity: 0, y: -20 }}
                transition={{ duration: 0.6, ease: [0.23, 1, 0.32, 1] }}
                className="absolute inset-0 flex items-center justify-center text-[13px] font-bold uppercase tracking-[0.2em] whitespace-nowrap px-6"
                style={{ backfaceVisibility: "hidden" }}
              >
                {labels[textIndex]}
              </motion.span>
            </AnimatePresence>
          </motion.button>

          <Link to="/RoleSelection" className="w-full sm:w-auto">
            <motion.button
              variants={buttonVariants}
              whileHover={{ scale: 1.03, backgroundColor: "#f8fafc" }}
              whileTap="tap"
              className="w-full min-w-[200px] bg-white text-slate-900 h-[60px] rounded-2xl text-[13px] font-bold uppercase tracking-[0.2em] shadow-xl transition-all duration-300"
            >
              Get Started
            </motion.button>
          </Link>
        </div>
      </section>

      {/* FOOTER COMPONENTS SECTION */}
      <div className="bg-[#1976D2]">
       <PopularCourses/>
       
        <HomeSucess />
        <Work />
        <HomePeermate />
        <HomeTestimony />
        <Categories />
        <Hubs />
        <TutorCards />
      </div>
    </>
  );
};

export default OutsourcingSection;